"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __importDefault(require("."));
var utils_1 = require("./utils");
var Property = /** @class */ (function () {
    function Property(descriptor) {
        this.playing = true;
        this.key = descriptor.key;
        this.type = descriptor.type;
        this.target = descriptor.target;
        this.suffix = descriptor.suffix;
        this.easing = descriptor.easing;
        this.timeline = {
            start: 0,
            duration: this.easing.duration,
            initial: descriptor.initial,
            final: descriptor.initial,
            current: descriptor.initial,
        };
        this._value = descriptor.initial;
        this.precision = descriptor.precision || 4;
    }
    Property.prototype.frame = function (delta) {
        var deltaT = performance.now() - this.timeline.start;
        var deltaTClamp = Math.min(Math.max(deltaT, 0), this.timeline.duration);
        var time = this.easing.mode(deltaTClamp / this.timeline.duration);
        this.timeline.current = this.timeline.initial + (time * (this.timeline.final - this.timeline.initial));
    };
    Property.prototype.render = function (delta) {
        if (!this.playing)
            return;
        if (this.target !== null && typeof this.target !== 'undefined') {
            var current = parseFloat(this.timeline.current.toFixed(this.precision));
            if (this.type === _1.default.PROPERTY_TYPE.TRANSFORM) {
                var transform = this.target.style.transform;
                if (transform !== null) {
                    var updated = utils_1.updateTransform(transform, this.key, this.value, this.suffix);
                    this.target.style.transform = updated || '';
                }
            }
            if (this.type === _1.default.PROPERTY_TYPE.STYLE) {
                this.target.style[this.key] = "" + current + this.suffix;
            }
            if (this.type === _1.default.PROPERTY_TYPE.ATTRIBUTE) {
                this.target.setAttribute(this.key, "" + current + this.suffix);
            }
        }
    };
    Property.prototype.postRender = function (delta) {
        this._value = this.timeline.current;
    };
    Object.defineProperty(Property.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this.timeline.start = performance.now();
            this.timeline.initial = this._value;
            this.timeline.final = value;
        },
        enumerable: true,
        configurable: true
    });
    Property.prototype.play = function (value) {
        if (typeof value === 'undefined')
            value = this.timeline.initial;
        this.timeline.start = performance.now();
        this.timeline.initial = value;
        this.timeline.current = value;
        this.timeline.final = value;
        this.playing = true;
    };
    Property.prototype.pause = function () {
        this.playing = false;
    };
    return Property;
}());
exports.default = Property;
